import React, { useState } from "react";
import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { Database, Sliders, LogOut, ArrowLeft, ToggleRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import MoonstoneWordmark from "../../components/MoonstoneWordmark";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const items = [
    { to: "/admin/contents", icon: Database, label: "Gestione Contenuti" },
    { to: "/admin/limits", icon: Sliders, label: "Impostazioni Limiti" },
    { to: "/admin/services", icon: ToggleRight, label: "Gestione Servizi" },
  ];

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#050505] text-white">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#0A0E17] flex flex-col">
        <div className="px-6 py-6 border-b border-white/10">
          <MoonstoneWordmark size="md" />
          <div className="text-[10px] mt-3 tracking-[0.2em] uppercase text-white/40">
            Admin Console
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1" data-testid="admin-nav">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={`admin-nav-${it.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded text-sm transition ${
                  isActive
                    ? "bg-[#00E5FF]/10 text-[#00E5FF]"
                    : "text-white/70 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <it.icon size={16} />
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-3 border-t border-white/10 space-y-1">
          <Link
            to="/dashboard"
            data-testid="admin-back-app"
            className="flex items-center gap-2 px-3 py-2 text-xs text-white/50 hover:text-white"
          >
            <ArrowLeft size={14} /> Back to App
          </Link>
          <button
            onClick={onLogout}
            data-testid="admin-logout"
            className="flex items-center gap-2 px-3 py-2 text-xs text-white/50 hover:text-[#FF3860] w-full"
          >
            <LogOut size={14} /> Logout
          </button>
          <div className="px-3 py-2 text-[10px] text-white/30 uppercase tracking-widest">
            {user?.email}
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
